var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIconAtInputHover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.5 13a5.5 5.5 0 100-11 5.5 5.5 0 000 11z",
    stroke: "#4C6AFF",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.438 14l-1.5-1.5-.75-.75-.188-.188",
    stroke: "#4C6AFF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjUgMTNDMTAuNTM3NiAxMyAxMyAxMC41Mzc2IDEzIDcuNUMxMyA0LjQ2MjQzIDEwLjUzNzYgMiA3LjUgMkM0LjQ2MjQzIDIgMiA0LjQ2MjQzIDIgNy41QzIgMTAuNTM3NiA0LjQ2MjQzIDEzIDcuNSAxM1oiIHN0cm9rZT0iIzRDNkFGRiIgc3Ryb2tlLXdpZHRoPSIxLjIiLz4KPHBhdGggZD0iTTE0LjQzNzUgMTRMMTIuOTM3NSAxMi41TDEyLjE4NzUgMTEuNzVMMTIgMTEuNTYyNSIgc3Ryb2tlPSIjNEM2QUZGIiBzdHJva2Utd2lkdGg9IjEuMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgSearchIconAtInputHover as ReactComponent };